import { render, staticRenderFns } from "./CrestViewStudentPrint.vue?vue&type=template&id=1c972e1e&scoped=true&"
import script from "./CrestViewStudentPrint.vue?vue&type=script&lang=js&"
export * from "./CrestViewStudentPrint.vue?vue&type=script&lang=js&"
import style0 from "./CrestViewStudentPrint.vue?vue&type=style&index=0&id=1c972e1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c972e1e",
  null
  
)

export default component.exports